var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _VideoManager_disabled, _VideoManager_observer, _VideoManager_videos, _VideoManager_playbackQueue, _VideoManager_onStatusChange;
var VideoManager = /** @class */ (function () {
    function VideoManager() {
        _VideoManager_disabled.set(this, void 0);
        _VideoManager_observer.set(this, void 0);
        _VideoManager_videos.set(this, []);
        _VideoManager_playbackQueue.set(this, new Set());
        _VideoManager_onStatusChange.set(this, void 0);
        __classPrivateFieldSet(this, _VideoManager_disabled, !this.isIntersectionObserverAvailable(), "f");
        if (__classPrivateFieldGet(this, _VideoManager_disabled, "f")) {
            return;
        }
        __classPrivateFieldSet(this, _VideoManager_observer, new IntersectionObserver(this.onIntersect.bind(this), { threshold: [0, 1] }), "f");
        __classPrivateFieldSet(this, _VideoManager_onStatusChange, this.processQueue.bind(this), "f");
    }
    VideoManager.prototype.add = function (video) {
        if (__classPrivateFieldGet(this, _VideoManager_disabled, "f")) {
            return;
        }
        __classPrivateFieldGet(this, _VideoManager_videos, "f").push(video);
        __classPrivateFieldGet(this, _VideoManager_observer, "f").observe(video.cover);
    };
    VideoManager.prototype.remove = function (video) {
        if (__classPrivateFieldGet(this, _VideoManager_disabled, "f")) {
            return;
        }
        var index = __classPrivateFieldGet(this, _VideoManager_videos, "f").indexOf(video);
        if (index === -1) {
            return;
        }
        __classPrivateFieldGet(this, _VideoManager_observer, "f").unobserve(video.cover);
        __classPrivateFieldGet(this, _VideoManager_videos, "f").splice(index, 1);
        this.dequeueVideo(video);
    };
    VideoManager.prototype.processQueue = function () {
        var e_1, _a;
        var mayNeedReorder = false;
        try {
            loop: for (var _b = __values(__classPrivateFieldGet(this, _VideoManager_playbackQueue, "f")), _c = _b.next(); !_c.done; _c = _b.next()) {
                var video = _c.value;
                switch (video.status) {
                    case 'locked':
                        mayNeedReorder = true;
                        continue;
                    case 'error':
                    case 'done':
                        this.dequeueVideo(video);
                        continue;
                    case 'init':
                        video.preload();
                        break loop;
                    case 'playing':
                    case 'waiting':
                    case 'loading':
                        break loop;
                    case 'ready':
                        video.wait();
                        break loop;
                    case 'waited':
                        video.play();
                        break loop;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        // move locked to the end
        if (mayNeedReorder) {
            this.reorderQueue();
        }
    };
    VideoManager.prototype.enqueueVideo = function (video) {
        if (__classPrivateFieldGet(this, _VideoManager_playbackQueue, "f").has(video)) {
            return;
        }
        __classPrivateFieldGet(this, _VideoManager_playbackQueue, "f").add(video);
        video.addListener(__classPrivateFieldGet(this, _VideoManager_onStatusChange, "f"));
    };
    VideoManager.prototype.dequeueVideo = function (video) {
        if (!__classPrivateFieldGet(this, _VideoManager_playbackQueue, "f").has(video)) {
            return;
        }
        __classPrivateFieldGet(this, _VideoManager_playbackQueue, "f").delete(video);
        video.removeListener(__classPrivateFieldGet(this, _VideoManager_onStatusChange, "f"));
    };
    VideoManager.prototype.onIntersect = function (entries) {
        var e_2, _a;
        var _this = this;
        var newVideos = [];
        try {
            for (var entries_1 = __values(entries), entries_1_1 = entries_1.next(); !entries_1_1.done; entries_1_1 = entries_1.next()) {
                var entry = entries_1_1.value;
                var video = this.getVideoByCover(entry.target);
                if (!video) {
                    continue;
                }
                if (entry.intersectionRatio === 0) {
                    this.dequeueVideo(video);
                    video.hide();
                }
                else if (entry.intersectionRatio === 1) {
                    newVideos.push(video);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (entries_1_1 && !entries_1_1.done && (_a = entries_1.return)) _a.call(entries_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        newVideos.sort(function () { return Math.random() - 0.5; }).forEach(function (video) { return _this.enqueueVideo(video); });
        this.processQueue();
    };
    VideoManager.prototype.getVideoByCover = function (cover) {
        var e_3, _a;
        try {
            for (var _b = __values(__classPrivateFieldGet(this, _VideoManager_videos, "f")), _c = _b.next(); !_c.done; _c = _b.next()) {
                var video = _c.value;
                if (cover === video.cover) {
                    return video;
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return null;
    };
    VideoManager.prototype.isIntersectionObserverAvailable = function () {
        return 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    };
    VideoManager.prototype.reorderQueue = function () {
        var e_4, _a;
        var locked = new Set();
        var unlocked = new Set();
        var valid = true;
        try {
            for (var _b = __values(__classPrivateFieldGet(this, _VideoManager_playbackQueue, "f")), _c = _b.next(); !_c.done; _c = _b.next()) {
                var video = _c.value;
                if (video.status === 'locked') {
                    locked.add(video);
                    continue;
                }
                unlocked.add(video);
                if (locked.size) {
                    valid = false;
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
        if (valid) {
            return;
        }
        __classPrivateFieldSet(this, _VideoManager_playbackQueue, new Set(__spreadArray(__spreadArray([], __read(unlocked), false), __read(locked), false)), "f");
    };
    return VideoManager;
}());
_VideoManager_disabled = new WeakMap(), _VideoManager_observer = new WeakMap(), _VideoManager_videos = new WeakMap(), _VideoManager_playbackQueue = new WeakMap(), _VideoManager_onStatusChange = new WeakMap();
export default VideoManager;
